'use client'

import React, { useEffect, useMemo } from 'react'
import AntdRegistry from '@/app/_providers/AntdRegistry'
import AntdProvider from '@/app/_providers/AntdProvider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { usePathname, useRouter } from 'next/navigation'
import { ROUTE_HOME } from '@/constants/routes'

export default function Providers({ children }: { children: React.ReactNode }) {
  const router = useRouter()
  const pathname = usePathname()

  const queryClient = useMemo(
    () =>
      // https://tkdodo.eu/blog/breaking-react-querys-api-on-purpose
      // https://tanstack.com/query/v4/docs/react/reference/QueryCache
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
          },
        },
      }),
    [],
  )

  useEffect(() => {
    const handleError = (error: any, redirectToSignIn?: boolean | unknown) => {
      if (
        error?.status === 401 &&
        (redirectToSignIn ?? true) &&
        pathname !== ROUTE_HOME
      ) {
        router.push(ROUTE_HOME)
      }
    }

    queryClient.getQueryCache().config.onError = (error: any, query) => {
      handleError(error, query.meta?.redirectToSignIn)
    }
    queryClient.getMutationCache().config.onError = (
      error: any,
      variables,
      context,
      mutation,
    ) => {
      handleError(error, mutation.meta?.redirectToSignIn)
    }
  }, [pathname, queryClient, router])

  return (
    <AntdRegistry>
      <AntdProvider>
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </AntdProvider>
    </AntdRegistry>
  )
}
